import React from 'react';

require('./stylesheets/Welcome.scss');

const Welcome = (props) => {
  return (
    <div className="row">
      <div className="intro">
        <div className="img-wrapper">
          <img src="/images/me.jpg" alt="Nathan Kleekamp" width="300" height="300" className="circular" />
        </div>
        <h2 className="intro-header center-text">Welcome.<span className="cursor">&nbsp;</span></h2>
        <p className="intro-text">I am a developer with more than 5 years of experience developing web-based applications that adhere to industry best practices.</p>
      </div>
    </div>
  );
};

export default Welcome;



// WEBPACK FOOTER //
// ./app/src/Home/components/Welcome.js